var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("fabricsController", [
    "$scope", "$rootScope", "fabricsService", "elasticService", "randomService", "$interval",
    function (
        $scope, $rootscope, fabricsService, elasticService, randomService, $interval
    ) {

        $rootscope.activeBannerIndex = 0;
        $rootscope.activeAdIndex=0

        $scope.onBannerClick = function(index){
            if($scope.banners && $scope.banners.length > 0){
                $rootscope.activeBannerIndex = index;
            }
            else{
                $rootscope.activeBannerIndex = 0;
            }
        }
        
        $scope.onAdClick = function (index) {
            if($scope.customads && $scope.customads.length > 0){
                $rootscope.activeAdIndex = index;
            }
            else{
                $rootscope.activeAdIndex = 0;
            }
        };
        

        $scope.getFabricsPageContent = function(){
            fabricsService.getFabricsPageContent().then(
                function (response) {
                    if(response && response.data){
                        $scope.banners = response.data.banners;
                        $scope.customads = response.data.ads;
                        $scope.category = response.data.category;
                        $scope.material = response.data.material;
                        $scope.sports = response.data.sports;
                        $scope.themes = response.data.themes;
                        if(response.data.colors){
                            $scope.colorAd = response.data.colors[0].colorAd;
                            $scope.colors = response.data.colors[1].color;
                        }
                        $scope.projectAds = response.data.projectAds;

                        $scope.carousalInterval = $interval(
                            function(){
                                val = 1;
                                if ($scope.banners && $scope.banners.length > 0) {
                                    if (!(($scope.banners.length - 1 == $rootscope.activeBannerIndex && Number(val) > 0) || ($rootscope.activeBannerIndex == 0 && Number(val) < 0))) {
                                        $rootscope.activeBannerIndex = Number($rootscope.activeBannerIndex) + Number(val);
                                    }
                                    else {
                                        $rootscope.activeBannerIndex = 0;
                                    }
                                }
                            }, 5000
                        );
                    }
                }
            );
        }
        $scope.getFabricsPageContent();
        getNewArrivals();

        function filterData(data, key, value) {
            var filteredData = data.filter(
                function (data) {
                    return (data[key] && data[key].toLowerCase()) == value.toLowerCase()
                }
            );
            return (filteredData && filteredData != null && filteredData.length > 0) ? filteredData[0] : undefined;
        }

        //#region New Arrivals
        function getNewArrivals() {
            elasticService.getElasticData(elasticService.buildNewArrivalsRequest(
                ["Fabric"], 100)
            ).then(
                function (response) {
                    if (response && 'aggregations' in response.data) {
                       var newArrivals = response.data.aggregations.definitions.buckets;
                        $scope.newFabrics = randomService.getRandomItemsfromListArray(
                            filterData(newArrivals, "key", "Fabric").topByDefinitions.hits.hits
                        );
                    }
                }
            );
        }
        //#endregion
    }
]);
